export const CHEMICAL_DB_API_HOST = import.meta.env.VITE_CHEMICAL_DB_API_BASE_URL;

export const JSON_HEADERS = { 'Content-Type': 'application/json' };

export const APPLICATION_CHEMICALS_PATH = (applicationId: string): string =>
    `/api/applications/${applicationId}/chemicals`;

export const APPLICATION_CHEMICALS_SEED_PATH = (applicationId: string): string =>
    `/api/applications/${applicationId}/chemicals/seed-from-mix`;

export const APPLICATION_MIX_PATH = (applicationId: string): string =>
    `/api/applications/${applicationId}/mix`;
